import './CoralVideo.scss'

import { AppProviderContext } from '@websrc/App/AppContext'
import { Asset } from '@websrc/App/Components/Asset/Asset'
import { CTA } from '@websrc/App/Components/CTA'
import { matomo } from '@websrc/App/Tracking/Matomo'
import { mapCoralWebVideo } from '@websrc/DataMappers/mapSpot'
import React, { FC, useContext } from 'react'

type CoralVideoProps = ReturnType<typeof mapCoralWebVideo>

export const CoralVideo: FC<CoralVideoProps> = ({ video, description, sign_up, image }) => {
  const { matomoPageTemplate } = useContext(AppProviderContext)
  return (
    <div className={'coral-video-container'}>
      {video && (
        <Asset className={'coral-video__video'} thumbnail={video.thumbnail} video={video.video} />
      )}
      <div className={'coral-video__content-container'}>
        <div className={'coral-video__content'}>
          <h3 className={'coral-video__header'}>{description}</h3>
          {sign_up.button && (
            <CTA
              className={'coral-video__cta'}
              cta={sign_up.button}
              onClick={() => {
                matomo.trackEvent(
                  'conversion',
                  matomoPageTemplate,
                  ['coral announcement page video spot'],
                  ['coral sign up button'],
                  'button'
                )
              }}
            />
          )}
          {sign_up.fine_copy && <p className={'coral-video__fine-copy'}>{sign_up?.fine_copy}</p>}
          {image && (
            <Asset className={'coral-video__image'} objectFit={'cover'} thumbnail={image} />
          )}
        </div>
      </div>
    </div>
  )
}
